import type { TContactParam } from '@cian/newbuilding-chat-component';
import { useSelector } from 'react-redux';

import { useBuilderChatHost } from './useBuilderChatHost';
import { getBuilderChatContact } from '../../selectors/builderChat';
import { getGaLabel } from '../../selectors/newbuilding';

interface IParams {
  isChatOpened: boolean;
}

export const useBuilderChatUrl = ({ isChatOpened }: IParams): string | undefined => {
  const chatHost = useBuilderChatHost();
  const chatContact = useSelector(getBuilderChatContact);
  const gaLabel = useSelector(getGaLabel);

  if (!isChatOpened) {
    return undefined;
  }

  const {
    realtyUserId,
    chat: { defaultMessage, entityId, context },
  } = chatContact as TContactParam;

  return (
    `${chatHost}/dialogs/?hostType=frame&entityId=${entityId}&entityType=newbuilding&receiverUserId=${realtyUserId}` +
    `${context ? '&context=' + encodeURIComponent(window.btoa(JSON.stringify(context))) : ''}` +
    `${defaultMessage ? '&defaultMessage=' + encodeURIComponent(defaultMessage) : ''}` +
    `${gaLabel ? '&gaLabel=' + encodeURIComponent(gaLabel) : ''}` +
    '&noDefaultMsgIfChatExists=1' +
    '&pageType=CardJK'
  );
};
